import Settings from "../../settings.json";
import axios from "axios";

const url = Settings.isNative ? Settings.frontlineArServer : "";

export class RtcRequester {

    static async createSupportRoom(workspace, emailToInvite, deviceId) {
        const result = await axios.post(`${url}/room-management/support-room/${workspace}/create/`, {
            emailToInvite,
            deviceId
        });
        return result.data;
    }

    static async getRoom(roomId, password) {
        const result = await axios.post(`${url}/room-management/support-room/get`, {
            RoomIdentifier: roomId,
            Password: password
        });
        return result.data;
    }

    static async ping(roomIdentifier, password, deviceId, guestName, deviceType, transcriptionToken = '') {
        const result = await axios.post(`${url}/room-management/support-room/ping`, {
            roomIdentifier, password, deviceId, guestName, deviceType, transcriptionToken
        });
        return result.data;
    }

    static async inviteUser(roomIdentifier, password, userId) {
        await axios.post(`${url}/room-management/invite-user`, {
            roomIdentifier, password, userId
        });
    }

    static async getRoomWorkspaceIsHP(roomId) {
        const result = await axios.get(`${url}/room-management/support-room/check-is-hp/${roomId}`);
        return result.data;
    }

    static async createOrUpdateRoomSession(roomData) {
        const result = await axios.put(`${url}/room-management/support-session/update-session`, roomData);
        return result.data;
    }

    static async updateRoomSnapshots(workspace, roomId, associatedFiles) {
        await axios.post(`${url}/room-management/${workspace}/update-room-snapshots`, {
            roomId,
            associatedFiles
        });
    }

    static async startRecording(workspace, roomId) {
        const result = await axios.post(`${url}/room-management/support-room/${workspace}/start-recording`, {
            roomId
        });
        return result.data;
    }

    static async getActiveRecording(workspace, roomId, recordingId) {
        const result = await axios.post(`${url}/room-management/support-room/${workspace}/get-active-recording`, {
            roomId,
            recordingId
        });
        return result.data;
    }

    static async updateRecordingStatus(workspace, roomId, payload) {
        const result = await axios.post(`${url}/room-management/support-room/${workspace}/update-recording-status`, {
            roomId,
            ...payload
        });
        return result.data;
    }

    static async finalizeRecording(workspace, roomId, recordingId) {
        const result = await axios.post(`${url}/room-management/support-room/${workspace}/finalize-recording`, {
            roomId,
            recordingId,
        });
        return result.data;
    }
}
